import { GenericHeaderStyles, Header } from "../styled-components/headers";

export default function GenericHeader(props) {
  return (
    <GenericHeaderStyles>
      <div
        className={`generic-header__content generic-header__content--no-topics pt-12 md:pt-12`}
      >
        <Header className="generic-header__title">
          <h1 className={!props.section?.menus?.length ? `mt-24` : ``}>
            {props.title}
          </h1>
        </Header>
      </div>
    </GenericHeaderStyles>
  );
}
